import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';

import Dialog from '../../components/Dialog';
import { Typography, Button } from '../../components/Wrappers/Wrappers';
import { useStyles } from './iconDialog.styles';
import CheckCircleOutlineOutlinedIcon from '@material-ui/icons/CheckCircleOutlineOutlined';

function IconDialog ({
  open,
  onClose,
  onConfirm,
  title,
  message,
  confirmLabel,
  cancelLabel,
  showSecondaryButton,
  showPrimaryButton,
  icon,
  accentColor,
  confirmButtonColor,
}) {
  const classes = useStyles({ accentColor, confirmButtonColor: confirmButtonColor || accentColor });
  const Icon = icon;
  const isTwoButtonRow = showSecondaryButton && showPrimaryButton;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      disableBackdropClick
      PaperProps={{
        classes: {
          root: classes.dialogContainer,
        },
      }}
    >
      <Grid className={classes.content}>
        <Icon className={classes.tickIcon} aria-hidden="true"/>
        <Grid className={classes.textbox}>
          <Typography variant={'h5'} weight={'medium'} className={classes.successTitle}>
            {title}
          </Typography>
          <Typography variant={'body'} weight={'medium'} className={classes.successTitle}>
            {message}
          </Typography>
        </Grid>
        {isTwoButtonRow ? (
          <Grid className={classes.buttonRow}>
            <Button
              variant="outlined"
              className={classes.secondaryButton}
              onClick={onClose}
            >
              {cancelLabel}
            </Button>
            <Button
              variant="contained"
              className={classes.primaryButton}
              color={'white'}
              onClick={onConfirm}
            >
              {confirmLabel}
            </Button>
          </Grid>
        ) : (
          <React.Fragment>
            {showSecondaryButton && (
              <Button
                variant="outlined"
                className={classes.okButton}
                onClick={onClose}
              >
                {cancelLabel}
              </Button>
            )}
            {showPrimaryButton && (
              <Button
                variant="contained"
                className={classes.okButton}
                color={'white'}
                onClick={onConfirm}
              >
                {confirmLabel}
              </Button>
            )}
          </React.Fragment>
        )}
      </Grid>
    </Dialog>
  );
}

IconDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
  title: PropTypes.string,
  message: PropTypes.string,
  confirmLabel: PropTypes.string,
  cancelLabel: PropTypes.string,
  showSecondaryButton: PropTypes.bool,
  showPrimaryButton: PropTypes.bool,
  icon: PropTypes.elementType,
  accentColor: PropTypes.string,
  confirmButtonColor: PropTypes.string,
};

IconDialog.defaultProps = {
  open: false,
  onClose: () => {},
  onConfirm: () => {},
  title: "You're all set!",
  message: "Thanks for confirming it's you",
  confirmLabel: 'Ok',
  cancelLabel: 'CANCEL',
  showSecondaryButton: true,
  showPrimaryButton: true,
  icon: CheckCircleOutlineOutlinedIcon,
  accentColor: '#00d456',
};

export default IconDialog;
